<template>
    <div class="incoming glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <div>
                <div class="d-flex flex-wrap" style="gap: 7px;">
                    <b-alert variant="secondary" show class="glass-alert" style="display: inline-block; vertical-align: top;">
                        <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                            <b-form-select size="sm" :options="get_locations()" v-model="drop_location" class="glass-select">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- COMING TO --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                            <b-button variant="success" style="display: inline-block;" size="sm" @click="fetch_init2" class="glass-btn">SEARCH</b-button>
                        </div>
                    </b-alert>

                    <div
                      v-if="isMobile && items.length > 0"
                      class="d-flex justify-content-between align-items-center mb-2 px-1"
                    >
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="filtersVisible = !filtersVisible"
                        class="glass-filter-btn"
                      >
                        <b-icon-funnel-fill class="mr-1" />
                        {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                      </b-button>
                    </div>

                    <b-collapse :visible="!isMobile || filtersVisible">
                      <b-alert
                        variant="primary"
                        show
                        style="display: flex; flex-wrap: wrap; gap: 7px; vertical-align: top; padding: 13px;"
                        v-if="items.length > 0"
                        class="glass-filters"
                      >
                        <!-- Date Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_date"
                            :options="available_dates"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DATE --</b-form-select-option>
                              <b-form-select-option :value="null">ALL DATES</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Driver Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_driver"
                            :options="available_drivers"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DRIVER --</b-form-select-option>
                              <b-form-select-option :value="null">ALL DRIVERS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Status Filter -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_status"
                            :options="available_statuses"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- STATUS --</b-form-select-option>
                              <b-form-select-option :value="null">ALL STATUS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Coming From -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_ship_locsub"
                            :options="available_ship_locsubs"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- COMING FROM --</b-form-select-option>
                              <b-form-select-option :value="null">ALL LOCATIONS</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <!-- Order Type -->
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_order_type"
                            :options="available_order_types"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- ORDER TYPE --</b-form-select-option>
                              <b-form-select-option :value="null">ALL TYPES</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>
                      </b-alert>
                    </b-collapse>
                </div>
            </div>
        </div>

        <div style="width: 100%; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                    </loading>
                </div>
                <div v-else>
                    <!-- Bulk Action Bar -->
                    <div v-if="selectedItems.length > 0" class="bulk-action-bar glass-card">
                        <div class="bulk-action-content">
                            <span class="selected-count">{{ selectedItems.length }} item(s) selected</span>
                            <div class="bulk-actions">
                                <b-form-select
                                    v-model="bulkActionState"
                                    class="bulk-state-select glass-select"
                                    :options="getBulkStateOptions()"
                                    style="width: 200px; font-size: 14px; font-weight: bold;"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">Change Status to...</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-button
                                    variant="primary"
                                    @click="applyBulkStateUpdate"
                                    :disabled="!bulkActionState || isBulkUpdating"
                                    class="apply-bulk-btn glass-btn"
                                >
                                    {{ isBulkUpdating ? 'Updating...' : 'Apply to Selected' }}
                                </b-button>
                                <b-button
                                    variant="outline-secondary"
                                    @click="clearSelection"
                                    class="clear-selection-btn"
                                    :disabled="isBulkUpdating"
                                >
                                    Clear Selection
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="items.length > 0" class="diver">
                        <table style="width: 100%;" class="glass-table">
                            <thead>
                                <tr style="font-size: 14px; text-align: center;">
                                    <th class="srr glass-table-header" style="width: 40px;">
                                        <b-form-checkbox
                                            v-model="selectAll"
                                            @change="toggleSelectAll"
                                            class="select-all-checkbox"
                                            :disabled="isBulkUpdating"
                                        ></b-form-checkbox>
                                    </th>
                                    <th class="srr glass-table-header" style="width: 100px;" @click="sortby('invoice_id')">
                                        INVOICE #
                                    </th>
                                    <th class="srr glass-table-header" style="width: 100px;">
                                        DELIVERY DATE
                                    </th>
                                    <th class="srr glass-table-header" style="width: 100px;" @click="sortby('product_sku')">
                                        PRD SKU
                                    </th>
                                    <th class="srr glass-table-header" style="width: 220px;" @click="sortby('product_name')">
                                        PRD NAME
                                    </th>
                                    <th class="srr glass-table-header" style="width: 120px;" @click="sortby('order_type')">
                                        ORDER TYPE
                                    </th>
                                    <th class="srr glass-table-header" style="width: 50px;" @click="sortby('quantity')">
                                        QTY
                                    </th>
                                    <th class="srr glass-table-header" style="width: 220px;" @click="sortby('locsub')">
                                        ITEM PICK FROM
                                    </th>
                                    <th class="srr glass-table-header" style="width: 220px;" @click="sortby('ship_locsub')">
                                        COMING FROM
                                    </th>
                                    <th class="srr glass-table-header" style="width: 220px;" @click="sortby('drop_locsub')">
                                        DELIVERY LOC
                                    </th>
                                    <th class="srr glass-table-header" style="width: 80px;"@click="sortby('pickup_truck')">
                                        PICKUP TRUCK
                                    </th>
                                    <th class="srr glass-table-header" style="width:250px;" @click="sortby('state')">
                                        STATUS
                                    </th>
                                    <th class="srr glass-table-header" style="width:80px;">
                                        ACTION
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in filtered" :key="idx" class="glass-table-row">
                                    <td class="srrv">
                                        <b-form-checkbox
                                            v-model="selectedItems"
                                            :value="getItemIdentifier(item)"
                                            @change="updateSelectAll"
                                            class="item-checkbox"
                                            :disabled="isBulkUpdating || should_disable_checkbox(item)"
                                        ></b-form-checkbox>
                                    </td>
                                    <td class="srrv">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_sku }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_name }}
                                    </td>
                                    <td class="srrv">
                                        <div v-if="item.order_type == 'home_delivery'">
                                            <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HD</b-alert>
                                        </div>
                                        <div v-else-if="item.order_type == 'store_pickup'">
                                            <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                        </div>
                                        <div v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANFER</b-alert>
                                        </div>
                                        <div v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            <b-alert show variant="secondary" style="padding: 2px; font-size: 11px; text-align: center;">DAMAGE ORDER</b-alert>
                                        </div>
                                        <div v-else>
                                            {{item.order_type}}
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        {{ item.quantity }}
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locsubsdict[item.original_locsub || item.locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                           {{packet.locsubsdict[item.locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                          {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                             {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                             {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.trucksdict[item.truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                           {{packet.trucksdict[item.truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                         {{packet.trucksdict[item.pickup_truck] || 'NA'}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <b-form-select
                                            size="sm"
                                            :style="{textAlign: 'left'}"
                                            :options="getFilteredStates(item)"
                                            v-model="item.state"
                                            v-on:change="update_invoice_item_state(item)"
                                            :disabled="item.state !== 30 && packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK' || isBulkUpdating"
                                            class="glass-status-select"
                                        ></b-form-select>
                                    </td>
                                    <td class="srrv hidden-print">
                                        <button class="glass-comment-btn" @click="show_comments(item)" :disabled="isBulkUpdating">CMNT</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from 'bootstrap-vue'

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "Incoming",
        components: {flatPickr, Loading, ItemComments, DatePicker},
        data: function(){
            return {
                items: [],
                date_range: [],
                picked_date_range: null,
                dates: [],
                drop_location: null,
                active_date:null,
                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,
                selected_ship_locsub: null,
                available_ship_locsubs: [],
                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,
                states: mappings.states.map(function(d){
                    let stateOption = {...d};
                    if(d.value == 13) stateOption.text = "DROPPED AT STORE";
                    if(d.value == 4) stateOption.text = "RECEIVED FROM MECCA SHIPPING";
                    if(d.value == -4) stateOption.text = "CANT RECEIVED FROM MECCA SHIPPING";
                    if(d.value == 5) stateOption.text = "READY TO SHIP";
                    if(d.value == -5) stateOption.text = "CANT READY TO SHIP";
                    return stateOption;
                }),
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                sort_asc: true,
                trucks: [],
                incoming_types: [
                    {value: null, text: "ALL"},
                    {value: "CUSTOMER_ORDER", text: "CUSTOMER ORDER"},
                    {value: "STORE_TRANSFER_ORDER", text: "STORE TRANSFER ORDER"},
                ],
                selected_date: null,
                selected_driver: null,
                selected_status: null,
                selected_drop_location: null,
                available_dates: [],
                available_drivers: [],
                available_statuses: [],
                available_drop_locations: [],
                selected_order_type: null,
                available_order_types: [],
                picked_incoming_type: null,
                selected_state: null,
                filtersVisible: false,
                isMobile: false,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Incoming Items',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "📦 Fetching incoming items...",
                    "🚚 Loading delivery schedules...",
                    "📍 Syncing location data...",
                    "📊 Processing orders...",
                    "🔄 Updating inventory...",
                    "✨ Organizing items...",
                    "📈 Preparing data..."
                ],
                // Multi-select properties
                selectedItems: [],
                selectAll: false,
                bulkActionState: null,
                isBulkUpdating: false,
                bulkUpdateComplete: false,
                isUpdating: false
            }
        },
        mounted: function() {
          this.handleResize();
          window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize);
          if (this.loadingInterval) clearInterval(this.loadingInterval);
          if (this.tipInterval) clearInterval(this.tipInterval);
          if (this.msgInterval) clearInterval(this.msgInterval);
        },
        computed: {
            filtered: function(){
                let that = this;
                return this.items.filter(function(d){
                    const dateMatch = that.selected_date ? d.delivery_date === that.selected_date : true;
                    const driverMatch = that.selected_driver ?
                        (d.pickup_truck == that.selected_driver || d.truck == that.selected_driver) : true;
                    const statusMatch = that.selected_status ?
                        that.getStatusText(d.state) === that.selected_status : true;
                    const shipLocsubMatch = that.selected_ship_locsub ?
                        d.ship_locsub == that.selected_ship_locsub : true;
                    const orderTypeMatch = that.selected_order_type ?
                        that.getOrderTypeForFilter(d) === that.selected_order_type : true;
                    return dateMatch && driverMatch && statusMatch && shipLocsubMatch && orderTypeMatch;
                });
            }
        },
        watch: {
            selected_date: function() {
                this.updateAvailableDrivers();
                this.updateAvailableStatuses();
                this.updateAvailableShipLocsubs();
                this.updateAvailableOrderTypes();
            },
            items: function() {
                this.updateAvailableDates();
                this.updateAvailableDrivers();
                this.updateAvailableStatuses();
                this.updateAvailableShipLocsubs();
                this.updateAvailableOrderTypes();
            },
            selectedItems: function() {
                this.updateSelectAll();
            }
        },
        methods: {
            // ========== MULTI-SELECT METHODS ==========
            getItemIdentifier: function(item) {
                return `${item.invoice_id}|${item.itemid}`;
            },

            toggleSelectAll: function() {
                if (this.selectAll) {
                    const allIds = this.items.map(item => this.getItemIdentifier(item));
                    this.selectedItems = allIds;
                } else {
                    this.selectedItems = [];
                }
            },

            updateSelectAll: function() {
                const filteredIds = this.items.map(item => this.getItemIdentifier(item));
                if (filteredIds.length === 0) {
                    this.selectAll = false;
                    return;
                }
                this.selectAll = filteredIds.every(id => this.selectedItems.includes(id));
            },

            clearSelection: function() {
                this.selectedItems = [];
                this.selectAll = false;
                this.bulkActionState = null;
            },

            should_disable_checkbox: function(item) {
                return this.packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK';
            },

            getBulkStateOptions: function() {
                let userrole = this.packet.userDetails.userrole;
                let allStates = [...this.states];
                
                // For non-admin users, limit available states
                if (userrole !== "admin") {
                    allStates = allStates.filter(state => 
                        [13, 4, -4, 5, -5].includes(state.value)
                    );
                }
                
                return allStates.map(state => ({
                    value: state.value,
                    text: state.text
                }));
            },

            getSelectedItemsData: function() {
                return this.items.filter(item => {
                    const identifier = this.getItemIdentifier(item);
                    return this.selectedItems.includes(identifier);
                });
            },

            applyBulkStateUpdate: function() {
                if (!this.bulkActionState || this.isBulkUpdating) return;

                const selectedItems = this.getSelectedItemsData();
                if (selectedItems.length === 0) {
                    this.$bvToast.toast(
                        "No items selected for bulk update.",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.$bvModal.msgBoxConfirm(
                    `Are you sure you want to update ${selectedItems.length} item(s) to status: ${this.getStatusText(this.bulkActionState)}?`,
                    {
                        title: 'Confirm Bulk Update',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }
                ).then(value => {
                    if (value) {
                        this.processBulkStateUpdate(selectedItems);
                    }
                }).catch(err => {
                    // Handle cancellation
                });
            },

            getStatusText(state) {
                const statusObj = mappings.states.find(s => s.value === state);
                return statusObj ? statusObj.text : "UNKNOWN";
            },

            processBulkStateUpdate: function(selectedItems) {
                this.isBulkUpdating = true;
                this.bulkUpdateComplete = false;
                this.startApiLoading(`Updating ${selectedItems.length} items`);

                const that = this;
                let completed = 0;
                let successful = 0;
                let failed = 0;
                let errors = [];

                const batchSize = 5;
                const batches = this.chunkArray(selectedItems, batchSize);

                let batchPromises = batches.map((batch, batchIndex) => {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            this.processBulkBatch(batch, (batchSuccess, batchErrors) => {
                                successful += batchSuccess;
                                failed += batchErrors.length;
                                errors = errors.concat(batchErrors);
                                completed += batch.length;
                                
                                const progress = Math.min(Math.round((completed / selectedItems.length) * 90), 90);
                                that.loadingProgress = progress;
                                that.loadingMessage = `Updating ${completed}/${selectedItems.length} items...`;
                                
                                resolve();
                            });
                        }, batchIndex * 300);
                    });
                });

                Promise.all(batchPromises).then(() => {
                    that.loadingProgress = 100;
                    that.loadingMessage = 'Finalizing...';
                    
                    setTimeout(() => {
                        that.stopApiLoading(true);
                        that.isBulkUpdating = false;
                        that.bulkUpdateComplete = true;
                        that.clearSelection();

                        let message = `Bulk update completed: ${successful} successful`;
                        if (failed > 0) {
                            message += `, ${failed} failed`;
                        }
                        that.$bvToast.toast(
                            message,
                            {
                                title: failed > 0 ? "Partial Success" : "Success",
                                autoHideDelay: 3000,
                                variant: failed > 0 ? "warning" : "success"
                            }
                        );

                        if (errors.length > 0) {
                            console.error('Bulk update errors:', errors);
                            const errorMessage = errors.slice(0, 3).join('\n');
                            if (errors.length > 3) {
                                that.$bvToast.toast(
                                    `${errorMessage}\n... and ${errors.length - 3} more errors`,
                                    {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                                );
                            } else {
                                that.$bvToast.toast(
                                    errorMessage,
                                    {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                                );
                            }
                        }
                    }, 500);
                }).catch(error => {
                    console.error('Bulk update error:', error);
                    that.stopApiLoading(false);
                    that.isBulkUpdating = false;
                    that.$bvToast.toast(
                        "An unexpected error occurred during bulk update.",
                        {title: "Error", autoHideDelay: 3000, variant:"danger"}
                    );
                });
            },

            processBulkBatch: function(batch, callback) {
                let successful = 0;
                let errors = [];
                let completed = 0;
                const that = this;

                batch.forEach((item, index) => {
                    const originalState = item.state;
                    that.$set(item, 'state', that.bulkActionState);

                    let incomingType = this.determineIncomingType(item);

                    let data = {
                        invoice_id: item.invoice_id,
                        itemid: item.itemid,
                        state: that.bulkActionState,
                        changed_by: that.packet.userDetails.username,
                        product_sku: item.product_sku,
                        quantity: item.quantity,
                        incoming_type: incomingType,
                        drop_location: item.drop_location,
                        drop_locsub: item.drop_locsub,
                        ship_locsub: item.ship_locsub,
                        original_locsub: item.original_locsub,
                        pickup_truck: item.pickup_truck,
                        bulk_update: true
                    };

                    setTimeout(() => {
                        Requestor.postAsync(
                            "/api/sales/update_invoice_item_state/",
                            data,
                            function(response) {
                                if (response.data.error) {
                                    that.$set(item, 'state', originalState);
                                    errors.push(`Item ${item.invoice_id}: ${response.data.error}`);
                                } else {
                                    successful++;
                                    if (response.data.result) {
                                        const updatedData = response.data.result;
                                        const index = that.items.findIndex(i => 
                                            i.invoice_id === item.invoice_id && i.itemid === item.itemid
                                        );
                                        if (index !== -1) {
                                            that.$set(that.items, index, {...that.items[index], ...updatedData});
                                        }
                                    }
                                }
                                completed++;
                                if (completed === batch.length) {
                                    callback(successful, errors);
                                }
                            },
                            function(error) {
                                that.$set(item, 'state', originalState);
                                errors.push(`Item ${item.invoice_id}: Network error`);
                                completed++;
                                if (completed === batch.length) {
                                    callback(successful, errors);
                                }
                            }
                        );
                    }, index * 150);
                });
            },

            chunkArray: function(array, size) {
                const chunks = [];
                for (let i = 0; i < array.length; i += size) {
                    chunks.push(array.slice(i, i + size));
                }
                return chunks;
            },

            determineIncomingType: function(item) {
                let incomingType = item.incoming_type || '';
                if (!incomingType) {
                    if (item.order_type === 'home_delivery' || item.order_type === 'store_pickup') {
                        incomingType = 'CUSTOMER_ORDER';
                    } else if (item.invoice_id && item.invoice_id.toString().includes('TRANSFER')) {
                        incomingType = 'STORE_TRANSFER_ORDER';
                    } else if (item.invoice_id && item.invoice_id.toString().includes('DAMAGE')) {
                        incomingType = 'DAMAGE_ORDER';
                    } else {
                        incomingType = 'CUSTOMER_ORDER';
                    }
                }
                return incomingType;
            },

            // Loading animation methods
            startApiLoading(message = 'Loading Incoming Items') {
                this.stopApiLoading(true);
                this.apiCallStack = 1;
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 8;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    } else {
                        this.currentTipIndex = 0;
                    }
                }, 2500);
                
                let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 2000);
            },
            
            stopApiLoading(success = true) {
                if (this.loadingInterval) {
                    clearInterval(this.loadingInterval);
                    this.loadingInterval = null;
                }
                if (this.tipInterval) {
                    clearInterval(this.tipInterval);
                    this.tipInterval = null;
                }
                if (this.msgInterval) {
                    clearInterval(this.msgInterval);
                    this.msgInterval = null;
                }
                
                this.apiCallStack = 0;
                
                if (success) {
                    this.loadingProgress = 100;
                    this.loadingMessage = 'Complete!';
                    setTimeout(() => {
                        this.apiLoading = false;
                        this.loadingProgress = 0;
                    }, 400);
                } else {
                    this.apiLoading = false;
                    this.loadingProgress = 0;
                }
            },

            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
            getOrderTypeForFilter(item) {
                if (item.incoming_type === 'STORE_TRANSFER_ORDER') {
                    return 'store_transfer';
                }
                return item.order_type;
            },
            updateAvailableOrderTypes() {
                const orderTypeCounts = {};
                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const orderType = this.getOrderTypeForFilter(item);
                        let displayText = '';
                        switch(orderType) {
                            case 'home_delivery':
                                displayText = 'HOME DELIVERY';
                                break;
                            case 'store_pickup':
                                displayText = 'STORE PICKUP';
                                break;
                            case 'store_transfer':
                                displayText = 'STORE TRANSFER';
                                break;
                            default:
                                displayText = orderType || 'UNKNOWN';
                        }
                        if (orderType) {
                            const existingCount = orderTypeCounts[orderType] ? orderTypeCounts[orderType].count : 0;
                            orderTypeCounts[orderType] = {
                                name: displayText,
                                count: existingCount + 1
                            };
                        }
                    }
                });
                this.available_order_types = Object.keys(orderTypeCounts).map(orderType => ({
                    value: orderType,
                    text: `${orderTypeCounts[orderType].name} (${orderTypeCounts[orderType].count})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            updateAvailableShipLocsubs() {
                const shipLocsubCounts = {};
                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const shipLocsub = item.ship_locsub;
                        let locationName = '';
                        if (item.incoming_type == 'CUSTOMER_ORDER') {
                            locationName = this.packet.locsubsdict[shipLocsub] || shipLocsub;
                        } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
                            locationName = this.packet.locationsdict[shipLocsub] || shipLocsub;
                        }
                        if (locationName) {
                            const existingCount = shipLocsubCounts[shipLocsub] ? shipLocsubCounts[shipLocsub].count : 0;
                            shipLocsubCounts[shipLocsub] = {
                                name: locationName,
                                count: existingCount + 1
                            };
                        }
                    }
                });
                this.available_ship_locsubs = Object.keys(shipLocsubCounts).map(shipLocsubId => ({
                    value: shipLocsubId,
                    text: `${shipLocsubCounts[shipLocsubId].name} (${shipLocsubCounts[shipLocsubId].count})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            getFilteredStates(item) {
                let userrole = this.packet.userDetails.userrole;
                const allStates = this.states;
                const shouldEnableState = (stateValue) => {
                    if (userrole === "admin") {
                        return true;
                    }
                    const allowedForNonAdmin = [13, 4, -4, 5, -5];
                    if (!allowedForNonAdmin.includes(item.state)) {
                        return stateValue === item.state;
                    }
                    return allowedForNonAdmin.includes(stateValue);
                };
                return allStates.map(state => {
                    const enable = shouldEnableState(state.value);
                    const isCurrent = state.value === item.state;
                    return {
                        ...state,
                        disabled: !enable,
                        text: isCurrent ? `${state.text}` : state.text,
                        style: isCurrent ? { fontWeight: 'bold', backgroundColor: '#f0f8ff' } : {}
                    };
                });
            },
            updateAvailableDates() {
                const dateCounts = {};
                this.items.forEach(item => {
                    if (item.delivery_date) {
                        dateCounts[item.delivery_date] = (dateCounts[item.delivery_date] || 0) + 1;
                    }
                });
                this.available_dates = Object.keys(dateCounts).map(date => ({
                    value: date,
                    text: `${date} (${dateCounts[date]})`
                }));
                this.selected_date = null;
            },
            updateAvailableDrivers() {
                const driverSet = new Set();
                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        if (item.pickup_truck && this.packet.trucksdict[item.pickup_truck]) {
                            driverSet.add(item.pickup_truck);
                        }
                        if (item.truck && this.packet.trucksdict[item.truck]) {
                            driverSet.add(item.truck);
                        }
                    }
                });
                this.available_drivers = Array.from(driverSet).map(driverKey => ({
                    value: driverKey,
                    text: this.packet.trucksdict[driverKey] || driverKey
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            updateAvailableStatuses() {
                const statusCounts = {};
                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const statusText = this.getStatusText(item.state);
                        statusCounts[statusText] = (statusCounts[statusText] || 0) + 1;
                    }
                });
                this.available_statuses = Object.keys(statusCounts).map(statusText => ({
                    value: statusText,
                    text: `${statusText} (${statusCounts[statusText]})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            updateAvailableDropLocations() {
                const dropLocationCounts = {};
                this.items.forEach(item => {
                    if (!this.selected_date || item.delivery_date === this.selected_date) {
                        const dropLocation = item.drop_location;
                        const locationName = this.packet.locationsdict[dropLocation] || dropLocation;
                        if (locationName) {
                            const existingCount = dropLocationCounts[dropLocation] ? dropLocationCounts[dropLocation].count : 0;
                            dropLocationCounts[dropLocation] = {
                                name: locationName,
                                count: existingCount + 1
                            };
                        }
                    }
                });
                this.available_drop_locations = Object.keys(dropLocationCounts).map(locationId => ({
                    value: locationId,
                    text: `${dropLocationCounts[locationId].name} (${dropLocationCounts[locationId].count})`
                })).sort((a, b) => a.text.localeCompare(b.text));
            },
            allowed: function(item){
                let status = true;
                let allowed_item = this.allowed_item(item);
                let filtered_location = this.filtered_location(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);
                if (allowed_item && filtered_location && filtered_pickup_truck){
                    status = true;
                } else {
                    status = false;
                }
                return status;
            },
            allowed_item: function(item){
                let status = true;
                let userrole = this.packet.userDetails.userrole;
                let item_location_id = item.drop_location;
                if (userrole == "admin" || userrole == "officeuser") {
                    status = true;
                } else {
                    if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                        let location_id = parseInt(this.packet.userDetails.properties.location_id);
                        if (location_id == item.item_location_id){
                            status = true;
                        } else {
                            status = false;
                        }
                    } else {
                        status = false;
                    }
                }
                return status;
            },
            filtered_location: function(item){
                let status = true;
                if (this.picked_location_id) {
                    if (item.drop_location == this.picked_location_id){
                        status = true;
                    } else {
                        status = false;
                    }
                }
                return status;
            },
            filtered_pickup_truck: function(item){
                let status = true;
                if (this.picked_pickup_truck) {
                    if (item.pickup_truck == this.picked_pickup_truck){
                        status = true;
                    } else {
                        status = false;
                    }
                }
                return status;
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid = item.itemid;
                this.$bvModal.show("modal-comments");
            },

            // ========== FIXED UPDATE METHOD ==========
            update_invoice_item_state: function(item){
                if (this.isUpdating) {
                    return;
                }
                this.isUpdating = true;
                
                let path = "/api/sales/update_invoice_item_state/";
                let that = this;
                const originalState = item.state;
                
                let incomingType = this.determineIncomingType(item);

                let data = {
                    invoice_id: item.invoice_id, 
                    itemid: item.itemid, 
                    state: item.state, 
                    changed_by: this.packet.userDetails.username, 
                    product_sku: item.product_sku, 
                    quantity: item.quantity,
                    incoming_type: incomingType,
                    drop_location: item.drop_location,
                    drop_locsub: item.drop_locsub,
                    ship_locsub: item.ship_locsub,
                    original_locsub: item.original_locsub,
                    pickup_truck: item.pickup_truck
                };

                let s = function(response) {
                    that.isUpdating = false;
                    
                    if (response.data.error){
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                        that.$set(item, 'state', originalState);
                    } else {
                        that.$bvToast.toast("Success updating item state.", {title: "Success", autoHideDelay: 1500, variant:"success"});
                        
                        if (response.data.result) {
                            const updatedData = response.data.result;
                            const index = that.items.findIndex(i => 
                                i.invoice_id === item.invoice_id && i.itemid === item.itemid
                            );
                            if (index !== -1) {
                                that.$set(that.items, index, {...that.items[index], ...updatedData});
                            }
                        }
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.isUpdating = false;
                    that.$bvToast.toast("Error updating item state.", {title: "Error", autoHideDelay: 1500, variant:"danger"});
                    that.$set(item, 'state', originalState);
                }
                Requestor.postAsync(path, data, s, f);
            },

            fetch_init2: function(){
                let path = "/api/sales/get_incoming_items_for_date_range_store/";
                let that = this;
                this.startApiLoading('Fetching Incoming Items');
                this.clearSelection();
                
                let dateRange = this.date_range && this.date_range.length > 0
                    ? this.date_range.filter(d => d !== null)
                    : [moment().format("MM-DD-YYYY"), moment().format("MM-DD-YYYY")];
                let data = { date_range: dateRange, drop_location: this.drop_location };
                if (!data.drop_location && this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id){
                    this.$bvToast.toast("Please select an incoming location", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    this.stopApiLoading();
                    return;
                }
                let s = function(response) {
                    that.items_being_loaded = false;
                    if (response && response.data && response.data.result){
                        that.items = response.data.result;
                        that.selected_date = null;
                        that.selected_driver = null;
                        that.selected_status = null;
                        that.selected_ship_locsub = null;
                        that.selected_order_type = null;
                        that.clearSelection();
                    } else {
                        let errorMsg = "Unknown error occurred";
                        if (response && response.data && response.data.error) errorMsg = response.data.error;
                        that.$bvToast.toast(errorMsg, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                        that.items = [];
                    }
                    that.stopApiLoading();
                }
                let f = function(error) {
                    that.items_being_loaded = false;
                    console.error("API Error:", error);
                    let errorMsg = "Network error loading incoming items";
                    if (error && error.response && error.response.data && error.response.data.error) errorMsg = error.response.data.error;
                    that.$bvToast.toast(errorMsg, {title: "Error", autoHideDelay: 1500, variant:"danger"});
                    that.items = [];
                    that.stopApiLoading();
                    that.clearSelection();
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },

            get_incoming_items_for_date: function(){
                let path = "/api/sales/get_incoming_items_for_date/";
                let that = this;
                let data = {date: this.picked_date};
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    } else {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error loading incoming items.", {title: "Error", autoHideDelay: 1500, variant:"danger"});
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },

            get_incoming_dates_for_year_month: function(){
                let path = "/api/sales/get_incoming_dates_for_year_month/";
                let that = this;
                let data = {year: this.year, month: this.month};
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                        that.dates = that.dates.map(function(d){ return {value: d.date, text: d.date + ' ('+d.nitems+')' } });
                    } else {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    }
                    that.dates_being_loaded = false;
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error loading incoming dates.", {title: "Error", autoHideDelay: 1500, variant:"danger"});
                    that.dates_being_loaded = false;
                }
                this.dates = [];
                this.items = [];
                this.picked_date = null;
                this.picked_location = null;
                Requestor.postAsync(path, data, s, f);
            },

            fetch_prereqs: function(){},
            fetch: function(type){
                this.type = type;
                this.items = [];
                this.dates = [];
                this.active_date = null;
                this.locsub = null;
            },

            sortby: function(key, mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key, mapper);
                } else {
                    this.items = Requestor.sort_reverse(this.items, key, mapper);
                }
                this.sort_asc = !this.sort_asc;
            },

            set_dates: function(value){
                let start = null;
                let end = null;
                if(value == 'today') { start = moment().format("MM-DD-YYYY"); end = moment().format("MM-DD-YYYY"); }
                if(value == 'yesterday') { start = moment().add(-1, 'days').format("MM-DD-YYYY"); end = moment().add(-1, 'days').format("MM-DD-YYYY"); }
                if(value == 'this_week') { start = moment().startOf('week').format("MM-DD-YYYY"); end = moment().endOf('week').format("MM-DD-YYYY"); }
                if(value == 'last_week') { start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY"); end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY"); }
                if(value == 'this_month') { start = moment().startOf('month').format("MM-DD-YYYY"); end = moment().endOf('month').format("MM-DD-YYYY"); }
                if(value == 'last_month') { start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY"); end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY"); }
                if (start && end) {
                    this.date_range = [start, end];
                    this.picked_date_range = value;
                }
            },

            get_locations: function(){
                let output = [{value: null, text: "PICK LOCATION", disabled: true}];
                let user_location = this.packet.userDetails.properties.location_id;
                const MECCA_SHIPPING_ID = 47;
                if (user_location){
                    output = this.packet.locations.filter(function(d){
                        return d.value == user_location && d.value != MECCA_SHIPPING_ID;
                    });
                } else {
                    output = output.concat(this.packet.locations.filter(function(d){
                        return d.text != 'All' &&
                               d.value != 46 && d.value != 44 && d.value != MECCA_SHIPPING_ID && d.value != 40 && d.value != 41 && d.value != 42;
                    }));
                }
                return output;
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;
            if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value));
                if (userLocation) {
                    this.drop_location = userLocation.value;
                    this.fetch_init2();
                }
            };
        }
    }
</script>

<style scoped>
    /* Glass Theme Container */
    .incoming.glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    /* Same background image */
    .incoming.glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Bulk Action Bar */
    .bulk-action-bar {
        padding: 12px 20px;
        margin-bottom: 15px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.95) !important;
        border: 2px solid rgba(66, 153, 225, 0.3) !important;
        box-shadow: 0 2px 12px rgba(66, 153, 225, 0.1) !important;
    }

    .bulk-action-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 15px;
    }

    .selected-count {
        font-weight: 600;
        color: #2d3748;
        margin-right: 10px;
        font-size: 14px;
    }

    .bulk-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        flex: 1;
    }

    .bulk-state-select {
        width: 200px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        border: 2px solid #495057 !important;
        border-radius: 8px !important;
        background: white !important;
        height: 40px !important;
    }

    .apply-bulk-btn {
        height: 40px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        padding: 0 20px !important;
        background: linear-gradient(135deg, #4299e1, #3182ce) !important;
        border: none !important;
        color: white !important;
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .apply-bulk-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3) !important;
    }

    .apply-bulk-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .clear-selection-btn {
        height: 40px !important;
        font-size: 13px !important;
        border: 2px solid #e2e8f0 !important;
        border-radius: 8px !important;
        color: #4a5568 !important;
        background: transparent !important;
        transition: all 0.3s ease !important;
    }

    .clear-selection-btn:hover:not(:disabled) {
        background: #f7fafc !important;
        border-color: #cbd5e0 !important;
    }

    .clear-selection-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Checkbox styles */
    .select-all-checkbox,
    .item-checkbox {
        transform: scale(1.2);
        margin: 0;
        cursor: pointer;
    }

    .select-all-checkbox:disabled,
    .item-checkbox:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .select-all-checkbox >>> .custom-control-label::before,
    .item-checkbox >>> .custom-control-label::before {
        border-radius: 4px !important;
    }

    /* Glass Card Effect */
    .glass-alert, .glass-filters {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Select */
    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }
    .glass-select:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, #28a745, #20c997) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 12px !important;
        padding: 8px 20px !important;
    }
    .glass-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    }

    .glass-filter-btn {
        background: rgba(0, 123, 255, 0.1) !important;
        border: 1px solid rgba(0, 123, 255, 0.3) !important;
        color: #007bff !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }
    .glass-filter-btn:hover {
        background: rgba(0, 123, 255, 0.2) !important;
        transform: scale(1.02);
    }

    /* Glass Comment Button */
    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    .glass-comment-btn:hover:not(:disabled) {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }
    .glass-comment-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Glass Status Select */
    .glass-status-select {
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }
    .glass-status-select:hover {
        transform: scale(1.02);
    }

    /* Glass Table */
    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }
    .glass-table-header {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
        padding: 12px !important;
    }
    .glass-table-row {
        transition: all 0.3s ease;
    }
    .glass-table-row:hover {
        background: rgba(255, 255, 255, 0.7) !important;
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Loading Overlay */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading-overlay-enter-active { animation: fadeIn 0.3s ease; }
    .loading-overlay-leave-active { animation: fadeOut 0.3s ease; }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }
    @keyframes cardPop { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }

    .loading-animation { margin-bottom: 32px; }
    .loading-ring { position: relative; width: 100px; height: 100px; margin: 0 auto; display: flex; align-items: center; justify-content: center; }
    .ring { position: absolute; width: 100%; height: 100%; border: 4px solid transparent; border-radius: 50%; animation: ringRotate 1.5s linear infinite; }
    .ring:nth-child(1) { border-top-color: #4299e1; border-left-color: #4299e1; animation-duration: 1s; }
    .ring:nth-child(2) { border-right-color: #48bb78; border-bottom-color: #48bb78; width: 80%; height: 80%; top: 10%; left: 10%; animation-duration: 1.2s; animation-direction: reverse; }
    .ring:nth-child(3) { border-left-color: #ed8936; border-bottom-color: #ed8936; width: 60%; height: 60%; top: 20%; left: 20%; animation-duration: 0.8s; }
    @keyframes ringRotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

    .loading-logo { font-size: 32px; font-weight: bold; animation: logoPulse 1.5s ease-in-out infinite; z-index: 1; }
    .loading-logo i { font-size: 40px; background: linear-gradient(135deg, #4299e1, #48bb78); -webkit-background-clip: text; background-clip: text; color: transparent; }
    @keyframes logoPulse { 0%, 100% { transform: scale(1); opacity: 0.7; } 50% { transform: scale(1.1); opacity: 1; } }

    .loading-text { margin-bottom: 24px; }
    .loading-text h3 { color: #2d3748; font-size: 1.3rem; margin-bottom: 8px; display: inline-block; }
    .loading-dots { display: inline-flex; margin-left: 8px; }
    .loading-dots .dot { width: 6px; height: 6px; background: #4299e1; border-radius: 50%; margin: 0 2px; animation: dotBounce 1.4s ease-in-out infinite; }
    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }
    @keyframes dotBounce { 0%, 60%, 100% { transform: translateY(0); } 30% { transform: translateY(-8px); } }

    .loading-progress { width: 100%; height: 4px; background: #e2e8f0; border-radius: 4px; overflow: hidden; margin-bottom: 20px; }
    .progress-bar { height: 100%; background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1); background-size: 200% 100%; animation: progressShine 1.5s linear infinite; transition: width 0.3s ease; border-radius: 4px; }
    @keyframes progressShine { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }

    .loading-tips { margin-top: 20px; }
    .tip-text { color: #718096; font-size: 0.9rem; animation: tipFade 0.5s ease; }
    @keyframes tipFade { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

    /* Existing styles */
    select option:disabled {
        color: #888 !important;
        font-style: italic;
        background-color: #f5f5f5 !important;
    }
    select option {
        padding: 8px 12px !important;
        font-size: 13px !important;
    }
    select option:not(:disabled) {
        font-weight: 600;
        background-color: white !important;
    }
    select option[disabled] {
        border-bottom: 1px solid #e0e0e0;
    }
    select option:not(:disabled):hover {
        background-color: #e8f5e9 !important;
    }
    select[size="sm"] {
        min-width: 250px !important;
    }
    select option[value=""] {
        font-style: normal !important;
        font-weight: bold !important;
        background: #f8f9fa !important;
    }

    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }
    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
    }
    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
    table {
        table-layout: fixed;
        width: 100%;
    }
    .ipt_tdr {
        background: none;
        text-align: center;
        font-size: 12px;
    }
    .ipt_tdhr {
        background: #343a40;
        color: white;
        font-weight: bold;
        text-align: center;
        font-size: 12px;
        border: 1px solid white;
    }
    @media (max-width: 768px) {
        .incoming.glass-theme {
            padding: 16px;
        }
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
        .glass-btn {
            margin-top: 10px;
        }
        .bulk-action-content {
            flex-direction: column;
            align-items: stretch;
        }
        .bulk-actions {
            flex-direction: column;
            align-items: stretch;
        }
        .bulk-state-select {
            width: 100% !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/StoreReceiving.vue